import { h, Fragment } from 'preact'
import Post from './Post';
import Loader from './Loader';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const Posts = props => {
  const { posts } = props;
  const activeClass = props.showAll ? 'active' : '';

  return (
    <div className="c-shop-overview__posts u-flex">
      {posts.map((post, index) => {
          return <Post key={post.id} post={post} />;
      })}

      {props.loading ? <Loader /> : null}
    </div>
  );
};

export default Posts;


// WEBPACK FOOTER //
// ./src/js/shop-overview/components/Posts.js